import { useState } from "react";
import internTestApi from "../../../api/serviceApi/internTestApi";

export default function CreateInternTest() {
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);
  const [testLink, setTestLink] = useState("");
  const [error, setError] = useState("");

  const generateTest = async () => {
    if (!role) {
      setError("Role / Drive name is required");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await internTestApi.post("api/intern-test/create-test", { role });

      const testId = res.data.testId;

      // ✅ Build correct test link
      const link = `${window.location.origin}/intern-test/${testId}`;

      setTestLink(link);

    } catch (err) {
      console.error(err);
      setError("Failed to generate test link");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl">
      <h1 className="text-2xl font-bold mb-2">
        Create Intern Assessment
      </h1>

      <p className="text-muted-foreground mb-6">
        This will generate a common test for all interns
      </p>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">
            Role / Drive Name
          </label>
          <input
            className="w-full border rounded-md px-3 py-2"
            placeholder="e.g. Summer Internship 2026"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          />
        </div>

        {error && (
          <p className="text-red-500 text-sm">{error}</p>
        )}

        <button
          onClick={generateTest}
          disabled={loading}
          className="bg-primary text-primary-foreground px-4 py-2 rounded-md"
        >
          {loading ? "Generating..." : "Generate Test Link"}
        </button>
      </div>

      {testLink && (
        <div className="mt-6 p-4 border rounded-md bg-muted">
          <p className="font-medium mb-2">🔗 Test Link</p>
          <div className="flex gap-2">
            <input
              className="flex-1 border rounded-md px-3 py-2 text-sm"
              value={testLink}
              readOnly
            />
            <button
              onClick={() => navigator.clipboard.writeText(testLink)}
              className="px-3 py-2 border rounded-md text-sm hover:bg-muted"
            >
              Copy
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
